export function getBatchJobStatusLabel(state: string | undefined) {
  if (state === 'completed') {
    return '已完成'
  }
  if (state === 'failed') {
    return '失败'
  }
  if (state === 'missing') {
    return '结果已过期'
  }
  return '处理中'
}

export function getBatchJobAlertType({
  state,
  failedCount,
  warningCount,
  showFailureAsError = true
}: {
  state: string | undefined
  failedCount: number
  warningCount: number
  showFailureAsError?: boolean
}) {
  if (state === 'failed' && showFailureAsError) {
    return 'error'
  }
  if (failedCount > 0 || warningCount > 0) {
    return 'warning'
  }
  return 'info'
}
